<template>
  <polygon points="9.44 20.99 7.67 19.23 14.86 12 7.67 4.77 9.44 3.01 18.39 12 9.44 20.99" />
</template>

<script>
export default {
  name: 'Icon' + 'ArrowThin'
};
</script>
